import { logEvent } from "firebase/analytics";
import app from "./FirebaseConfig";
import { analytics } from "./FirebaseConfig";
import {
  getAuth,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
  updateEmail,
  reauthenticateWithCredential,
  EmailAuthProvider,
  deleteUser as deleteAuthUser,
} from "firebase/auth";
import {
  getDatabase,
  ref,
  set,
  push,
  onValue,
  onChildAdded,
  update,
  remove,
} from "firebase/database";
import { Redirect } from "react-router-dom";

const auth = getAuth(app);
const database = getDatabase(app);

let signUpUser = (obj, nodeName) => {
  let { email, password } = obj;

  // === this promise will return on Signup page. ===
  return new Promise((resolve, reject) => {
    // === this "then" will give the status of Authentication. ===
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // user successfully registerd in authentication
        const user = userCredential.user;
        const refrence = ref(database, `${nodeName}/${user.uid}`);
        obj.id = user.uid;
        set(refrence, obj)
          // === this "then" will give the status of database function
          .then(() => {
            // this "resolve" is our custom message which will show in signup page "then"

            // this "resolve" is our custom message which will show in signup page "then"
            resolve("Account Created Successfully");
          })
          .catch((errr) => {
            reject(errr);
          });
      })
      .catch((err) => {
        reject("Account Not Created Or Already In Use");
      });
  });
};

let adminUser = (obj, nodeName) => {
  let { email, password } = obj;

  // === this promise will return on Signup page. ===
  return new Promise((resolve, reject) => {
    // === this "then" will give the status of Authentication. ===
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // user successfully registerd in authentication
        const user = userCredential.user;
        const refrence = ref(database, `${nodeName}/${user.uid}`);
        obj.id = user.uid;
        set(refrence, obj)
          // === this "then" will give the status of database function
          .then(() => {
            // this "resolve" is our custom message which will show in signup page "then"

            // this "resolve" is our custom message which will show in signup page "then"
            resolve("Created Successfully");
          })
          .catch((errr) => {
            reject(errr);
          });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

let loginUser = (obj, nodeName) => {
  let { email, password } = obj;
  return new Promise((resolve, reject) => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        // ...
        const reference = ref(database, `${nodeName}/${user.uid}`);
        onValue(reference, (e) => {
          let status = e.exists();
          // console.log(status);
          if (status) {
            resolve(e.val());
          } else {
            reject("Account Not Found :(");
          }
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
        reject(errorMessage);
      });
  });
};

let checkUser = () => {
  return new Promise((resolve, reject) => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        const uid = user.uid;
        resolve(uid);
      } else {
        // User is signed out
        reject("No user is Login ..");
      }
    });
  });
};

let sendData = (obj, nodeName, id) => {
  let postListRef;

  return new Promise((resolve, reject) => {
    if (id) {
      // edit case
      // id is present
      postListRef = ref(database, `${nodeName}/${id}`);
    } else {
      // add case
      // id is not available
      let addRef = ref(database, nodeName);
      obj.id = push(addRef).key;
      postListRef = ref(database, `${nodeName}/${obj.id}`);
    }
    set(postListRef, obj)
      .then(() => {
        resolve("Submit Successfully");
      })
      .catch((err) => {
        reject(err);
      });
  });
};

let getData = (nodeName, id) => {
  let refernece = ref(database, `${nodeName}/${id ? id : ""}`);
  return new Promise((resolve, reject) => {
    onValue(
      refernece,
      (snapshot) => {
        if (snapshot.exists()) {
          let data = snapshot.val();
          if (id) {
            resolve(data);
          } else {
            let arr = Object.values(data);
            resolve(arr);
          }
        } else {
          reject("No Data Found");
        }
      },
      {
        onlyOnce: false,
      }
    );
  });
};

let logoutUser = () => {
  return new Promise((resolve, reject) => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        resolve("user Logged Out successfully");
      })
      .catch((error) => {
        // An error happened.
        reject(error);
      });
  });
};

function deleteData(node, listId) {
  if (!listId) {
    let dbReference = ref(database, `${node}`);
    return new Promise((resolve, reject) => {
      set(dbReference, null)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  } else {
    let dbReference = ref(database, `${node}/${""}`);
    return new Promise((resolve, reject) => {
      set(dbReference, null)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

function deleteSingleObject(node, listKey) {
  let dbReference = ref(database, `${node}/${listKey}`);
  return new Promise((resolve, reject) => {
    set(dbReference, null)
      .then((res) => {
        resolve(`${listKey} Has Been Deleted`);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

let updateData = (obj, nodeName, id) => {
  let postListRef = ref(database, `${nodeName}/${id}`);
  return new Promise((resolve, reject) => {
    update(postListRef, obj)
      .then(() => {
        resolve("Update Successfully");
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getTotalVisitors = async () => {
  try {
    await logEvent(analytics, "page_view");
    const pageViewEvent = analytics.getLogEventByName("page_view");
    const totalCount = pageViewEvent.getTotalCount();
    return totalCount;
  } catch (error) {
    // console.error(error);
    return 0;
  }
};

async function changeEmailAndPassword(
  userId,
  currentPassword,
  newEmail,
  newPassword
) {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User not signed in.");
  }

  try {
    // Reauthenticate the user with their current email and password
    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    await reauthenticateWithCredential(user, credential);

    // Update email
    await updateEmail(user, newEmail);

    // Update password
    if (newPassword) {
      await updatePassword(user, newPassword);
    }

    // Update email and password in the database
    const updates = {};
    updates[`IqraHospital/${userId}/email`] = newEmail;
    updates[`IqraHospital/${userId}/password`] = newPassword;

    await update(ref(database), updates);

    return "Email and password updated successfully.";
  } catch (error) {
    console.error("Error updating email and password:", error);
    throw error;
  }
}

async function deleteUser(nodePath, userId, email, password) {
  try {
    // Delete user data from Realtime Database
    await remove(ref(database, `${nodePath}/${userId}`));

    // Get the current user
    const user = auth.currentUser;

    // Reauthenticate the user
    const credential = EmailAuthProvider.credential(email, password);
    await reauthenticateWithCredential(user, credential);

    // Delete user account from Authentication
    await deleteAuthUser(user);

    return "The user has been deleted successfully.";
  } catch (error) {
    throw new Error(
      "Failed to delete the user. Please try again later.",
      error
    );
  }
}

export {
  signUpUser,
  loginUser,
  checkUser,
  sendData,
  getData,
  logoutUser,
  adminUser,
  deleteData,
  deleteSingleObject,
  updateData,
  getTotalVisitors,
  changeEmailAndPassword,
  deleteUser,
};
